
import React, { useState, useEffect } from 'react';

function UserTable({ users, onEditUser, onManageAccess, isLevel1List = false }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!users || users.length === 0) {
    return <p>Ingen brukere funnet.</p>;
  }

  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ borderBottom: '1px solid #ddd' }}>
          <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Navn</th>
          {isLevel1List && !isMobile && <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Telefon</th>}
          {isLevel1List && !isMobile && <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>P-plass</th>}
          <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'left', width: '1%', whiteSpace: 'nowrap' }}>Handlinger</th>
        </tr>
      </thead>
      <tbody>
        {users.map(user => (
          <tr key={user.uid} style={{ borderBottom: '1px solid #ddd' }}>
            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.displayName || '-'}</td>
            {isLevel1List && !isMobile && <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.phone || '-'}</td>}
            {isLevel1List && !isMobile && <td style={{ border: '1px solid #ddd', padding: '8px' }}>{user.parking || '-'}</td>}
            <td style={{ border: '1px solid #ddd', padding: '8px', width: '1%', whiteSpace: 'nowrap' }}>
              <div style={{ display: 'flex', gap: '10px' }}>
                {onEditUser && <button onClick={() => onEditUser(user)}>Rediger</button>}
                {onManageAccess && <button onClick={() => onManageAccess(user)}>Administrer</button>}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default UserTable;
